import { css } from 'styled-components';
import { blenderCss } from '@clds/blender';

export const layoutCommon = css`
  ${blenderCss.populateVariables};
  background-color: ${blenderCss.backgroundFromCssVariables};
  border-radius: ${(props) => props.theme.radius.unstable_new.md};
`;
